export default [
    // //日志管理管理-财务日志
    // {
    //     path: "/financialLog",
    //     name: "financialLog",
    //     component: () => import("@/views/log/financialLog.vue"),
    //     meta: {
    //         noNeedCheckLogin: true,
    //     },
    // },
    //日志管理管理-开通日志
    {
        path: "/openingLog",
        name: "openingLog",
        component: () => import("@/views/log/openingLog.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
    //日志管理管理-出库日志
    {
        path: "/deliveryLog",
        name: "deliveryLog",
        component: () => import("@/views/log/deliveryLog.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
    //日志管理管理-激活日志
    {
        path: "/activationLog",
        name: "activationLog",
        component: () => import("@/views/log/activationLog.vue"),
        meta: {
            noNeedCheckLogin: true,
        },
    },
]